import { render, staticRenderFns } from "./ChipCreatedAt.vue?vue&type=template&id=c76bdabc&scoped=true&"
import script from "./ChipCreatedAt.vue?vue&type=script&lang=js&"
export * from "./ChipCreatedAt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../store/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76bdabc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../store/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
